import { useEffect, useState } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Menu } from "antd";
import { publicPath } from "@/utils/base";

import dataJson from "@/../public/data.json";

const prefix = "user";
import "./index.less";

function User() {
  const { user } = dataJson;
  const [current, setCurrent] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const onClick = (e: any) => {
    setCurrent(e.key);
    navigate(publicPath + e.item.props.url);
  };

  useEffect(() => {
    const pathArr = location.pathname.split("/");
    setCurrent(pathArr[pathArr.length - 1]);
  }, []);
  return (
    <div className={prefix}>
      <div className={`${prefix}-menu-wrap`}>
        <Menu
          onClick={onClick}
          mode="inline"
          items={user.menu}
          defaultOpenKeys={["1"]}
          selectedKeys={[current]}
          className={`${prefix}-menu`}
          expandIcon={(props: any) => {
            return (
              <img
                src={user.submenu_arrow_icon}
                className={`${prefix}-menu-arrow-icon ${props.isOpen ? "" : `${prefix}-menu-arrow-close`}`}
              />
            );
          }}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default User;
